import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconHapticFeedback: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconHapticFeedback"><Path d="M18.5 1.5H5.5V22.5H18.5V1.5Z" stroke="currentColor"/><Circle cx="12" cy="12" r="6.5" stroke="currentColor"/><Circle cx="12" cy="12" r="3" stroke="currentColor" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconHapticFeedback;
